<div class="pl-not-found__wrapper">
  <div class="pl-error-navigation-header">
    <a class="pl-error-navigation__link" (click)="goBack()">
      <se-icon class="pl-error-navigation__back-arrow" name="chevron-left" size="500"></se-icon>
      <p class="pl-error-navigation__back-text">{{backText}}</p>
    </a>
  </div>

  <div class="pl-site-section pl-error-content pl-text--center">
    <h3 class="pl-heading--caps-md30">ERROR: PAGE NOT FOUND</h3>
    <header class="pl-heading-group">
      <se-icon name="whistle-thin" size="950" class="se-icon--orange"></se-icon>
      <h1 class="pl-heading--primary-lg70 pl-heading--gray">Whoa, time out.</h1>
      <h2 class="pl-heading--secondary-lg70">That’s not in the playbook.</h2>
    </header>
  </div>

  <div class="pl-site-footer pl-error-footer">
    <img alt="SportsEngine" src="https://www.sportsengine.com/ui_themes/assets/latest/images/HQ_Primary_Logo_RGB_Full_Color.svg" class="pl-nav__se-logo">
    <div>© SportsEngine, LLC, The Home of Youth Sports. <span class="translation_missing" title="translation missing: en.app.all_rights_reserved">All Rights Reserved</span>.</div>
    <div>
      <a href="https://www.sportsengine.com/privacy-center/terms-of-use/" target="_blank" class="pl-link">
        Terms of Use
      </a>
      <span class="pl-spacer"> / </span>
      <a href="https://www.sportsengine.com/privacy-center/privacy-policy/" target="_blank" class="pl-link">
        Privacy Policy
      </a>
    </div>
  </div>
</div>
